"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractAddress = void 0;
const __1 = require("..");
function contractAddress(source) {
    let cell = new __1.Cell();
    let state = new __1.StateInit({ code: source.initialCode, data: source.initialData });
    state.writeTo(cell);
    let hash = cell.hash();
    return new __1.Address(source.workchain, hash);
}
exports.contractAddress = contractAddress;
